import RfiAddRecipientsModal from './RfiAddRecipientsModal.component';

export default RfiAddRecipientsModal;
